import { useState, useEffect } from 'react';
import { api } from '../api';
import { styles } from '../styles';
import { BackIcon, PlusIcon, Spinner } from '../components/Icons';

export default function CategoryManageScreen({ onBack, onEdit, onAddSubCategory }) {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/categories')
      .then(data => {
        setCategories(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div style={{ ...styles.screen, ...styles.centered }}>
        <Spinner />
      </div>
    );
  }

  const activeCats = categories.filter(c => c.is_active);
  const regularCats = activeCats.filter(c => c.parent_id === null && c.budget_type !== 'project');
  const projectRoots = activeCats.filter(c => c.parent_id === null && c.budget_type === 'project');
  const subCatsByParent = {};
  activeCats.filter(c => c.parent_id !== null).forEach(c => {
    if (!subCatsByParent[c.parent_id]) subCatsByParent[c.parent_id] = [];
    subCatsByParent[c.parent_id].push(c);
  });

  return (
    <div style={styles.screen}>
      <header style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>
          <BackIcon />
        </button>
        <h1 style={styles.headerTitle}>Categories</h1>
        <button style={manageStyles.addBtn} onClick={() => onEdit(null)}>
          <PlusIcon size={20} />
        </button>
      </header>

      <div style={manageStyles.list}>
        {regularCats.map(cat => (
          <div key={cat.id} style={manageStyles.item}>
            <button
              style={manageStyles.itemContent}
              onClick={() => onEdit(cat)}
            >
              <span style={manageStyles.name}>{cat.icon} {cat.name}</span>
              <span style={manageStyles.chevron}>›</span>
            </button>
          </div>
        ))}

        {projectRoots.length > 0 && (
          <>
            <p style={manageStyles.sectionLabel}>Projects</p>
            {projectRoots.map(proj => (
              <div key={proj.id} style={manageStyles.projectBlock}>
                <button
                  style={manageStyles.itemContent}
                  onClick={() => onEdit(proj)}
                >
                  <span style={manageStyles.name}>{proj.icon} {proj.name}</span>
                  <span style={manageStyles.chevron}>›</span>
                </button>
                {(subCatsByParent[proj.id] || []).map(sub => (
                  <button
                    key={sub.id}
                    style={manageStyles.subItemContent}
                    onClick={() => onEdit(sub)}
                  >
                    <span style={manageStyles.subName}>{sub.icon} {sub.name}</span>
                    <span style={manageStyles.chevron}>›</span>
                  </button>
                ))}
                <button
                  style={manageStyles.addSubBtn}
                  onClick={() => onAddSubCategory && onAddSubCategory(proj)}
                >
                  + Add sub-category
                </button>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}

const manageStyles = {
  addBtn: {
    width: 36,
    height: 36,
    borderRadius: 10,
    backgroundColor: '#6366f1',
    color: 'white',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  item: {
    backgroundColor: 'white',
    borderRadius: 12,
    border: '1px solid #e2e8f0',
    overflow: 'hidden',
  },
  projectBlock: {
    backgroundColor: 'white',
    borderRadius: 12,
    border: '1px solid #c7d2fe',
    overflow: 'hidden',
  },
  itemContent: {
    width: '100%',
    padding: 16,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    textAlign: 'left',
  },
  subItemContent: {
    width: '100%',
    padding: '12px 16px 12px 28px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#fafafa',
    borderTop: '1px solid #e2e8f0',
    border: 'none',
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: '#e2e8f0',
    cursor: 'pointer',
    textAlign: 'left',
  },
  name: {
    fontSize: 15,
    fontWeight: 500,
    color: '#1e293b',
  },
  subName: {
    fontSize: 14,
    color: '#475569',
  },
  chevron: {
    fontSize: 20,
    color: '#94a3b8',
  },
  sectionLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: '#94a3b8',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginTop: 8,
    marginBottom: 4,
  },
  addSubBtn: {
    width: '100%',
    padding: '10px 16px 10px 28px',
    backgroundColor: 'transparent',
    border: 'none',
    borderTopWidth: 1,
    borderTopStyle: 'dashed',
    borderTopColor: '#e2e8f0',
    color: '#6366f1',
    fontSize: 13,
    cursor: 'pointer',
    textAlign: 'left',
  },
};
